/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as DebugRouteImport } from './routes/debug'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as R404RouteImport } from './routes/404'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as LoginQuickRegisterRouteImport } from './routes/login/quick-register'
import { Route as DebugIdRouteImport } from './routes/debug.$id'
import { Route as ColorsIdRouteImport } from './routes/colors.$id'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as AuthMagicLinkRouteImport } from './routes/_auth/magic-link'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthHomeRouteImport } from './routes/_auth/home'
import { Route as AuthFavoritesRouteImport } from './routes/_auth/favorites'
import { Route as AuthAuthMobileRouteImport } from './routes/_auth/auth-mobile'
import { Route as AuthAuthRouteImport } from './routes/_auth/auth'
import { Route as AuthLayoutRouteImport } from './routes/_auth/_layout'
import { Route as AuthButtonViewRouteImport } from './routes/_auth/_buttonView'
import { Route as AuthDiplomaIdRouteImport } from './routes/_auth/diploma.$id'
import { Route as AuthButtonViewLayoutRouteImport } from './routes/_auth/_buttonView/_layout'
import { Route as AuthLayoutWatchIndexRouteImport } from './routes/_auth/_layout/watch/index'
import { Route as AuthLayoutSuppliersIndexRouteImport } from './routes/_auth/_layout/suppliers/index'
import { Route as AuthLayoutShowcasesIndexRouteImport } from './routes/_auth/_layout/showcases/index'
import { Route as AuthLayoutMySourceIndexRouteImport } from './routes/_auth/_layout/my-source/index'
import { Route as AuthLayoutMicroLearningsIndexRouteImport } from './routes/_auth/_layout/micro-learnings/index'
import { Route as AuthLayoutDestinationsIndexRouteImport } from './routes/_auth/_layout/destinations/index'
import { Route as AuthLayoutAttendIndexRouteImport } from './routes/_auth/_layout/attend/index'
import { Route as AuthLayoutShowcasesIdRouteImport } from './routes/_auth/_layout/showcases/$id'
import { Route as AuthLayoutContactIdRouteImport } from './routes/_auth/_layout/contact/$id'
import { Route as AuthButtonViewLayoutTrainingIndexRouteImport } from './routes/_auth/_buttonView/_layout/training/index'
import { Route as AuthButtonViewLayoutRetainIndexRouteImport } from './routes/_auth/_buttonView/_layout/retain/index'
import { Route as AuthButtonViewLayoutTrainingAppRouteImport } from './routes/_auth/_buttonView/_layout/training/_app'
import { Route as AuthButtonViewLayoutRetainAppRouteImport } from './routes/_auth/_buttonView/_layout/retain/_app'
import { Route as AuthButtonViewLayoutResourcesTypeRouteImport } from './routes/_auth/_buttonView/_layout/resources/_type'
import { Route as AuthButtonViewLayoutInfoIdRouteImport } from './routes/_auth/_buttonView/_layout/info/$id'
import { Route as AuthButtonViewLayoutFavoritesIdRouteImport } from './routes/_auth/_buttonView/_layout/favorites/$id'
import { Route as AuthButtonViewLayoutDirectoryIdRouteImport } from './routes/_auth/_buttonView/_layout/directory/$id'
import { Route as AuthButtonViewLayoutTrainingAppIdRouteImport } from './routes/_auth/_buttonView/_layout/training/_app/$id'
import { Route as AuthButtonViewLayoutRetainAppIdRouteImport } from './routes/_auth/_buttonView/_layout/retain/_app/$id'
import { Route as AuthButtonViewLayoutResourcesTypeTypeRouteImport } from './routes/_auth/_buttonView/_layout/resources/_type/$type'
import { Route as AuthButtonViewLayoutTrainingAppIdIndexRouteImport } from './routes/_auth/_buttonView/_layout/training/_app/$id/index'
import { Route as AuthButtonViewLayoutRetainAppIdIndexRouteImport } from './routes/_auth/_buttonView/_layout/retain/_app/$id.index'
import { Route as AuthButtonViewLayoutTrainingAppIdContentRouteImport } from './routes/_auth/_buttonView/_layout/training/_app/$id._content'
import { Route as AuthButtonViewLayoutResourcesTypeTypeIdRouteImport } from './routes/_auth/_buttonView/_layout/resources/_type/$type/_id'
import { Route as AuthButtonViewLayoutRetainAppIdChapterIndexRouteImport } from './routes/_auth/_buttonView/_layout/retain/_app/$id/$chapter.index'
import { Route as AuthButtonViewLayoutResourcesTypeTypeIdIdIndexRouteImport } from './routes/_auth/_buttonView/_layout/resources/_type/$type/_id.$id.index'
import { Route as AuthButtonViewLayoutTrainingAppIdContentChapterPageRouteImport } from './routes/_auth/_buttonView/_layout/training/_app/$id/_content/$chapter.$page'
import { Route as AuthButtonViewLayoutResourcesTypeTypeIdIdLibraryIndexRouteImport } from './routes/_auth/_buttonView/_layout/resources/_type/$type/_id.$id.library.index'

const AuthButtonViewLayoutTrainingRouteImport = createFileRoute(
  '/_auth/_buttonView/_layout/training',
)()
const AuthButtonViewLayoutRetainRouteImport = createFileRoute(
  '/_auth/_buttonView/_layout/retain',
)()
const AuthButtonViewLayoutResourcesRouteImport = createFileRoute(
  '/_auth/_buttonView/_layout/resources',
)()

const DebugRoute = DebugRouteImport.update({
  id: '/debug',
  path: '/debug',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const LoginQuickRegisterRoute = LoginQuickRegisterRouteImport.update({
  id: '/login/quick-register',
  path: '/login/quick-register',
  getParentRoute: () => rootRouteImport,
} as any)
const DebugIdRoute = DebugIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => DebugRoute,
} as any)
const ColorsIdRoute = ColorsIdRouteImport.update({
  id: '/colors/$id',
  path: '/colors/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMagicLinkRoute = AuthMagicLinkRouteImport.update({
  id: '/magic-link',
  path: '/magic-link',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHomeRoute = AuthHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFavoritesRoute = AuthFavoritesRouteImport.update({
  id: '/favorites',
  path: '/favorites',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuthMobileRoute = AuthAuthMobileRouteImport.update({
  id: '/auth-mobile',
  path: '/auth-mobile',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuthRoute = AuthAuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLayoutRoute = AuthLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => AuthRoute,
} as any)
const AuthButtonViewRoute = AuthButtonViewRouteImport.update({
  id: '/_buttonView',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDiplomaIdRoute = AuthDiplomaIdRouteImport.update({
  id: '/diploma/$id',
  path: '/diploma/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthButtonViewLayoutRoute = AuthButtonViewLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => AuthButtonViewRoute,
} as any)
const AuthButtonViewLayoutTrainingRoute =
  AuthButtonViewLayoutTrainingRouteImport.update({
    id: '/training',
    path: '/training',
    getParentRoute: () => AuthButtonViewLayoutRoute,
  } as any)
const AuthButtonViewLayoutRetainRoute =
  AuthButtonViewLayoutRetainRouteImport.update({
    id: '/retain',
    path: '/retain',
    getParentRoute: () => AuthButtonViewLayoutRoute,
  } as any)
const AuthButtonViewLayoutResourcesRoute =
  AuthButtonViewLayoutResourcesRouteImport.update({
    id: '/resources',
    path: '/resources',
    getParentRoute: () => AuthButtonViewLayoutRoute,
  } as any)
const AuthLayoutWatchIndexRoute = AuthLayoutWatchIndexRouteImport.update({
  id: '/watch/',
  path: '/watch/',
  getParentRoute: () => AuthLayoutRoute,
} as any)
const AuthLayoutSuppliersIndexRoute =
  AuthLayoutSuppliersIndexRouteImport.update({
    id: '/suppliers/',
    path: '/suppliers/',
    getParentRoute: () => AuthLayoutRoute,
  } as any)
const AuthLayoutShowcasesIndexRoute =
  AuthLayoutShowcasesIndexRouteImport.update({
    id: '/showcases/',
    path: '/showcases/',
    getParentRoute: () => AuthLayoutRoute,
  } as any)
const AuthLayoutMySourceIndexRoute = AuthLayoutMySourceIndexRouteImport.update({
  id: '/my-source/',
  path: '/my-source/',
  getParentRoute: () => AuthLayoutRoute,
} as any)
const AuthLayoutMicroLearningsIndexRoute =
  AuthLayoutMicroLearningsIndexRouteImport.update({
    id: '/micro-learnings/',
    path: '/micro-learnings/',
    getParentRoute: () => AuthLayoutRoute,
  } as any)
const AuthLayoutDestinationsIndexRoute =
  AuthLayoutDestinationsIndexRouteImport.update({
    id: '/destinations/',
    path: '/destinations/',
    getParentRoute: () => AuthLayoutRoute,
  } as any)
const AuthLayoutAttendIndexRoute = AuthLayoutAttendIndexRouteImport.update({
  id: '/attend/',
  path: '/attend/',
  getParentRoute: () => AuthLayoutRoute,
} as any)
const AuthLayoutShowcasesIdRoute = AuthLayoutShowcasesIdRouteImport.update({
  id: '/showcases/$id',
  path: '/showcases/$id',
  getParentRoute: () => AuthLayoutRoute,
} as any)
const AuthLayoutContactIdRoute = AuthLayoutContactIdRouteImport.update({
  id: '/contact/$id',
  path: '/contact/$id',
  getParentRoute: () => AuthLayoutRoute,
} as any)
const AuthButtonViewLayoutTrainingIndexRoute =
  AuthButtonViewLayoutTrainingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthButtonViewLayoutTrainingRoute,
  } as any)
const AuthButtonViewLayoutRetainIndexRoute =
  AuthButtonViewLayoutRetainIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthButtonViewLayoutRetainRoute,
  } as any)
const AuthButtonViewLayoutTrainingAppRoute =
  AuthButtonViewLayoutTrainingAppRouteImport.update({
    id: '/_app',
    getParentRoute: () => AuthButtonViewLayoutTrainingRoute,
  } as any)
const AuthButtonViewLayoutRetainAppRoute =
  AuthButtonViewLayoutRetainAppRouteImport.update({
    id: '/_app',
    getParentRoute: () => AuthButtonViewLayoutRetainRoute,
  } as any)
const AuthButtonViewLayoutResourcesTypeRoute =
  AuthButtonViewLayoutResourcesTypeRouteImport.update({
    id: '/_type',
    getParentRoute: () => AuthButtonViewLayoutResourcesRoute,
  } as any)
const AuthButtonViewLayoutInfoIdRoute =
  AuthButtonViewLayoutInfoIdRouteImport.update({
    id: '/info/$id',
    path: '/info/$id',
    getParentRoute: () => AuthButtonViewLayoutRoute,
  } as any)
const AuthButtonViewLayoutFavoritesIdRoute =
  AuthButtonViewLayoutFavoritesIdRouteImport.update({
    id: '/favorites/$id',
    path: '/favorites/$id',
    getParentRoute: () => AuthButtonViewLayoutRoute,
  } as any)
const AuthButtonViewLayoutDirectoryIdRoute =
  AuthButtonViewLayoutDirectoryIdRouteImport.update({
    id: '/directory/$id',
    path: '/directory/$id',
    getParentRoute: () => AuthButtonViewLayoutRoute,
  } as any)
const AuthButtonViewLayoutTrainingAppIdRoute =
  AuthButtonViewLayoutTrainingAppIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthButtonViewLayoutTrainingAppRoute,
  } as any)
const AuthButtonViewLayoutRetainAppIdRoute =
  AuthButtonViewLayoutRetainAppIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthButtonViewLayoutRetainAppRoute,
  } as any)
const AuthButtonViewLayoutResourcesTypeTypeRoute =
  AuthButtonViewLayoutResourcesTypeTypeRouteImport.update({
    id: '/$type',
    path: '/$type',
    getParentRoute: () => AuthButtonViewLayoutResourcesTypeRoute,
  } as any)
const AuthButtonViewLayoutTrainingAppIdIndexRoute =
  AuthButtonViewLayoutTrainingAppIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthButtonViewLayoutTrainingAppIdRoute,
  } as any)
const AuthButtonViewLayoutRetainAppIdIndexRoute =
  AuthButtonViewLayoutRetainAppIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthButtonViewLayoutRetainAppIdRoute,
  } as any)
const AuthButtonViewLayoutTrainingAppIdContentRoute =
  AuthButtonViewLayoutTrainingAppIdContentRouteImport.update({
    id: '/_content',
    getParentRoute: () => AuthButtonViewLayoutTrainingAppIdRoute,
  } as any)
const AuthButtonViewLayoutResourcesTypeTypeIdRoute =
  AuthButtonViewLayoutResourcesTypeTypeIdRouteImport.update({
    id: '/_id',
    getParentRoute: () => AuthButtonViewLayoutResourcesTypeTypeRoute,
  } as any)
const AuthButtonViewLayoutRetainAppIdChapterIndexRoute =
  AuthButtonViewLayoutRetainAppIdChapterIndexRouteImport.update({
    id: '/$chapter/',
    path: '/$chapter/',
    getParentRoute: () => AuthButtonViewLayoutRetainAppIdRoute,
  } as any)
const AuthButtonViewLayoutResourcesTypeTypeIdIdIndexRoute =
  AuthButtonViewLayoutResourcesTypeTypeIdIdIndexRouteImport.update({
    id: '/$id/',
    path: '/$id/',
    getParentRoute: () => AuthButtonViewLayoutResourcesTypeTypeIdRoute,
  } as any)
const AuthButtonViewLayoutTrainingAppIdContentChapterPageRoute =
  AuthButtonViewLayoutTrainingAppIdContentChapterPageRouteImport.update({
    id: '/$chapter/$page',
    path: '/$chapter/$page',
    getParentRoute: () => AuthButtonViewLayoutTrainingAppIdContentRoute,
  } as any)
const AuthButtonViewLayoutResourcesTypeTypeIdIdLibraryIndexRoute =
  AuthButtonViewLayoutResourcesTypeTypeIdIdLibraryIndexRouteImport.update({
    id: '/$id/library/',
    path: '/$id/library/',
    getParentRoute: () => AuthButtonViewLayoutResourcesTypeTypeIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/404': typeof R404Route
  '/debug': typeof DebugRouteWithChildren
  '/auth': typeof AuthAuthRoute
  '/auth-mobile': typeof AuthAuthMobileRoute
  '/favorites': typeof AuthFavoritesRoute
  '/home': typeof AuthHomeRoute
  '/login': typeof AuthLoginRoute
  '/magic-link': typeof AuthMagicLinkRoute
  '/register': typeof AuthRegisterRoute
  '/colors/$id': typeof ColorsIdRoute
  '/debug/$id': typeof DebugIdRoute
  '/login/quick-register': typeof LoginQuickRegisterRoute
  '/': typeof AuthIndexRoute
  '/diploma/$id': typeof AuthDiplomaIdRoute
  '/contact/$id': typeof AuthLayoutContactIdRoute
  '/showcases/$id': typeof AuthLayoutShowcasesIdRoute
  '/attend': typeof AuthLayoutAttendIndexRoute
  '/destinations': typeof AuthLayoutDestinationsIndexRoute
  '/micro-learnings': typeof AuthLayoutMicroLearningsIndexRoute
  '/my-source': typeof AuthLayoutMySourceIndexRoute
  '/showcases': typeof AuthLayoutShowcasesIndexRoute
  '/suppliers': typeof AuthLayoutSuppliersIndexRoute
  '/watch': typeof AuthLayoutWatchIndexRoute
  '/directory/$id': typeof AuthButtonViewLayoutDirectoryIdRoute
  '/favorites/$id': typeof AuthButtonViewLayoutFavoritesIdRoute
  '/info/$id': typeof AuthButtonViewLayoutInfoIdRoute
  '/resources': typeof AuthButtonViewLayoutResourcesTypeRouteWithChildren
  '/retain': typeof AuthButtonViewLayoutRetainAppRouteWithChildren
  '/training': typeof AuthButtonViewLayoutTrainingAppRouteWithChildren
  '/retain/': typeof AuthButtonViewLayoutRetainIndexRoute
  '/training/': typeof AuthButtonViewLayoutTrainingIndexRoute
  '/resources/$type': typeof AuthButtonViewLayoutResourcesTypeTypeIdRouteWithChildren
  '/retain/$id': typeof AuthButtonViewLayoutRetainAppIdRouteWithChildren
  '/training/$id': typeof AuthButtonViewLayoutTrainingAppIdContentRouteWithChildren
  '/retain/$id/': typeof AuthButtonViewLayoutRetainAppIdIndexRoute
  '/training/$id/': typeof AuthButtonViewLayoutTrainingAppIdIndexRoute
  '/retain/$id/$chapter': typeof AuthButtonViewLayoutRetainAppIdChapterIndexRoute
  '/training/$id/$chapter/$page': typeof AuthButtonViewLayoutTrainingAppIdContentChapterPageRoute
  '/resources/$type/$id': typeof AuthButtonViewLayoutResourcesTypeTypeIdIdIndexRoute
  '/resources/$type/$id/library': typeof AuthButtonViewLayoutResourcesTypeTypeIdIdLibraryIndexRoute
}
export interface FileRoutesByTo {
  '/404': typeof R404Route
  '/debug': typeof DebugRouteWithChildren
  '/auth': typeof AuthAuthRoute
  '/auth-mobile': typeof AuthAuthMobileRoute
  '/favorites': typeof AuthFavoritesRoute
  '/home': typeof AuthHomeRoute
  '/login': typeof AuthLoginRoute
  '/magic-link': typeof AuthMagicLinkRoute
  '/register': typeof AuthRegisterRoute
  '/colors/$id': typeof ColorsIdRoute
  '/debug/$id': typeof DebugIdRoute
  '/login/quick-register': typeof LoginQuickRegisterRoute
  '/': typeof AuthIndexRoute
  '/diploma/$id': typeof AuthDiplomaIdRoute
  '/contact/$id': typeof AuthLayoutContactIdRoute
  '/showcases/$id': typeof AuthLayoutShowcasesIdRoute
  '/attend': typeof AuthLayoutAttendIndexRoute
  '/destinations': typeof AuthLayoutDestinationsIndexRoute
  '/micro-learnings': typeof AuthLayoutMicroLearningsIndexRoute
  '/my-source': typeof AuthLayoutMySourceIndexRoute
  '/showcases': typeof AuthLayoutShowcasesIndexRoute
  '/suppliers': typeof AuthLayoutSuppliersIndexRoute
  '/watch': typeof AuthLayoutWatchIndexRoute
  '/directory/$id': typeof AuthButtonViewLayoutDirectoryIdRoute
  '/favorites/$id': typeof AuthButtonViewLayoutFavoritesIdRoute
  '/info/$id': typeof AuthButtonViewLayoutInfoIdRoute
  '/resources': typeof AuthButtonViewLayoutResourcesTypeRouteWithChildren
  '/retain': typeof AuthButtonViewLayoutRetainIndexRoute
  '/training': typeof AuthButtonViewLayoutTrainingIndexRoute
  '/resources/$type': typeof AuthButtonViewLayoutResourcesTypeTypeIdRouteWithChildren
  '/training/$id': typeof AuthButtonViewLayoutTrainingAppIdIndexRoute
  '/retain/$id': typeof AuthButtonViewLayoutRetainAppIdIndexRoute
  '/retain/$id/$chapter': typeof AuthButtonViewLayoutRetainAppIdChapterIndexRoute
  '/training/$id/$chapter/$page': typeof AuthButtonViewLayoutTrainingAppIdContentChapterPageRoute
  '/resources/$type/$id': typeof AuthButtonViewLayoutResourcesTypeTypeIdIdIndexRoute
  '/resources/$type/$id/library': typeof AuthButtonViewLayoutResourcesTypeTypeIdIdLibraryIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/404': typeof R404Route
  '/_auth': typeof AuthRouteWithChildren
  '/debug': typeof DebugRouteWithChildren
  '/_auth/_buttonView': typeof AuthButtonViewRouteWithChildren
  '/_auth/_layout': typeof AuthLayoutRouteWithChildren
  '/_auth/auth': typeof AuthAuthRoute
  '/_auth/auth-mobile': typeof AuthAuthMobileRoute
  '/_auth/favorites': typeof AuthFavoritesRoute
  '/_auth/home': typeof AuthHomeRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/magic-link': typeof AuthMagicLinkRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/colors/$id': typeof ColorsIdRoute
  '/debug/$id': typeof DebugIdRoute
  '/login/quick-register': typeof LoginQuickRegisterRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/_buttonView/_layout': typeof AuthButtonViewLayoutRouteWithChildren
  '/_auth/diploma/$id': typeof AuthDiplomaIdRoute
  '/_auth/_layout/contact/$id': typeof AuthLayoutContactIdRoute
  '/_auth/_layout/showcases/$id': typeof AuthLayoutShowcasesIdRoute
  '/_auth/_layout/attend/': typeof AuthLayoutAttendIndexRoute
  '/_auth/_layout/destinations/': typeof AuthLayoutDestinationsIndexRoute
  '/_auth/_layout/micro-learnings/': typeof AuthLayoutMicroLearningsIndexRoute
  '/_auth/_layout/my-source/': typeof AuthLayoutMySourceIndexRoute
  '/_auth/_layout/showcases/': typeof AuthLayoutShowcasesIndexRoute
  '/_auth/_layout/suppliers/': typeof AuthLayoutSuppliersIndexRoute
  '/_auth/_layout/watch/': typeof AuthLayoutWatchIndexRoute
  '/_auth/_buttonView/_layout/directory/$id': typeof AuthButtonViewLayoutDirectoryIdRoute
  '/_auth/_buttonView/_layout/favorites/$id': typeof AuthButtonViewLayoutFavoritesIdRoute
  '/_auth/_buttonView/_layout/info/$id': typeof AuthButtonViewLayoutInfoIdRoute
  '/_auth/_buttonView/_layout/resources': typeof AuthButtonViewLayoutResourcesRouteWithChildren
  '/_auth/_buttonView/_layout/resources/_type': typeof AuthButtonViewLayoutResourcesTypeRouteWithChildren
  '/_auth/_buttonView/_layout/retain': typeof AuthButtonViewLayoutRetainRouteWithChildren
  '/_auth/_buttonView/_layout/retain/_app': typeof AuthButtonViewLayoutRetainAppRouteWithChildren
  '/_auth/_buttonView/_layout/training': typeof AuthButtonViewLayoutTrainingRouteWithChildren
  '/_auth/_buttonView/_layout/training/_app': typeof AuthButtonViewLayoutTrainingAppRouteWithChildren
  '/_auth/_buttonView/_layout/retain/': typeof AuthButtonViewLayoutRetainIndexRoute
  '/_auth/_buttonView/_layout/training/': typeof AuthButtonViewLayoutTrainingIndexRoute
  '/_auth/_buttonView/_layout/resources/_type/$type': typeof AuthButtonViewLayoutResourcesTypeTypeRouteWithChildren
  '/_auth/_buttonView/_layout/retain/_app/$id': typeof AuthButtonViewLayoutRetainAppIdRouteWithChildren
  '/_auth/_buttonView/_layout/training/_app/$id': typeof AuthButtonViewLayoutTrainingAppIdRouteWithChildren
  '/_auth/_buttonView/_layout/resources/_type/$type/_id': typeof AuthButtonViewLayoutResourcesTypeTypeIdRouteWithChildren
  '/_auth/_buttonView/_layout/training/_app/$id/_content': typeof AuthButtonViewLayoutTrainingAppIdContentRouteWithChildren
  '/_auth/_buttonView/_layout/retain/_app/$id/': typeof AuthButtonViewLayoutRetainAppIdIndexRoute
  '/_auth/_buttonView/_layout/training/_app/$id/': typeof AuthButtonViewLayoutTrainingAppIdIndexRoute
  '/_auth/_buttonView/_layout/retain/_app/$id/$chapter/': typeof AuthButtonViewLayoutRetainAppIdChapterIndexRoute
  '/_auth/_buttonView/_layout/training/_app/$id/_content/$chapter/$page': typeof AuthButtonViewLayoutTrainingAppIdContentChapterPageRoute
  '/_auth/_buttonView/_layout/resources/_type/$type/_id/$id/': typeof AuthButtonViewLayoutResourcesTypeTypeIdIdIndexRoute
  '/_auth/_buttonView/_layout/resources/_type/$type/_id/$id/library/': typeof AuthButtonViewLayoutResourcesTypeTypeIdIdLibraryIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/404'
    | '/debug'
    | '/auth'
    | '/auth-mobile'
    | '/favorites'
    | '/home'
    | '/login'
    | '/magic-link'
    | '/register'
    | '/colors/$id'
    | '/debug/$id'
    | '/login/quick-register'
    | '/'
    | '/diploma/$id'
    | '/contact/$id'
    | '/showcases/$id'
    | '/attend'
    | '/destinations'
    | '/micro-learnings'
    | '/my-source'
    | '/showcases'
    | '/suppliers'
    | '/watch'
    | '/directory/$id'
    | '/favorites/$id'
    | '/info/$id'
    | '/resources'
    | '/retain'
    | '/training'
    | '/retain/'
    | '/training/'
    | '/resources/$type'
    | '/retain/$id'
    | '/training/$id'
    | '/retain/$id/'
    | '/training/$id/'
    | '/retain/$id/$chapter'
    | '/training/$id/$chapter/$page'
    | '/resources/$type/$id'
    | '/resources/$type/$id/library'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/404'
    | '/debug'
    | '/auth'
    | '/auth-mobile'
    | '/favorites'
    | '/home'
    | '/login'
    | '/magic-link'
    | '/register'
    | '/colors/$id'
    | '/debug/$id'
    | '/login/quick-register'
    | '/'
    | '/diploma/$id'
    | '/contact/$id'
    | '/showcases/$id'
    | '/attend'
    | '/destinations'
    | '/micro-learnings'
    | '/my-source'
    | '/showcases'
    | '/suppliers'
    | '/watch'
    | '/directory/$id'
    | '/favorites/$id'
    | '/info/$id'
    | '/resources'
    | '/retain'
    | '/training'
    | '/resources/$type'
    | '/training/$id'
    | '/retain/$id'
    | '/retain/$id/$chapter'
    | '/training/$id/$chapter/$page'
    | '/resources/$type/$id'
    | '/resources/$type/$id/library'
  id:
    | '__root__'
    | '/404'
    | '/_auth'
    | '/debug'
    | '/_auth/_buttonView'
    | '/_auth/_layout'
    | '/_auth/auth'
    | '/_auth/auth-mobile'
    | '/_auth/favorites'
    | '/_auth/home'
    | '/_auth/login'
    | '/_auth/magic-link'
    | '/_auth/register'
    | '/colors/$id'
    | '/debug/$id'
    | '/login/quick-register'
    | '/_auth/'
    | '/_auth/_buttonView/_layout'
    | '/_auth/diploma/$id'
    | '/_auth/_layout/contact/$id'
    | '/_auth/_layout/showcases/$id'
    | '/_auth/_layout/attend/'
    | '/_auth/_layout/destinations/'
    | '/_auth/_layout/micro-learnings/'
    | '/_auth/_layout/my-source/'
    | '/_auth/_layout/showcases/'
    | '/_auth/_layout/suppliers/'
    | '/_auth/_layout/watch/'
    | '/_auth/_buttonView/_layout/directory/$id'
    | '/_auth/_buttonView/_layout/favorites/$id'
    | '/_auth/_buttonView/_layout/info/$id'
    | '/_auth/_buttonView/_layout/resources'
    | '/_auth/_buttonView/_layout/resources/_type'
    | '/_auth/_buttonView/_layout/retain'
    | '/_auth/_buttonView/_layout/retain/_app'
    | '/_auth/_buttonView/_layout/training'
    | '/_auth/_buttonView/_layout/training/_app'
    | '/_auth/_buttonView/_layout/retain/'
    | '/_auth/_buttonView/_layout/training/'
    | '/_auth/_buttonView/_layout/resources/_type/$type'
    | '/_auth/_buttonView/_layout/retain/_app/$id'
    | '/_auth/_buttonView/_layout/training/_app/$id'
    | '/_auth/_buttonView/_layout/resources/_type/$type/_id'
    | '/_auth/_buttonView/_layout/training/_app/$id/_content'
    | '/_auth/_buttonView/_layout/retain/_app/$id/'
    | '/_auth/_buttonView/_layout/training/_app/$id/'
    | '/_auth/_buttonView/_layout/retain/_app/$id/$chapter/'
    | '/_auth/_buttonView/_layout/training/_app/$id/_content/$chapter/$page'
    | '/_auth/_buttonView/_layout/resources/_type/$type/_id/$id/'
    | '/_auth/_buttonView/_layout/resources/_type/$type/_id/$id/library/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  R404Route: typeof R404Route
  AuthRoute: typeof AuthRouteWithChildren
  DebugRoute: typeof DebugRouteWithChildren
  ColorsIdRoute: typeof ColorsIdRoute
  LoginQuickRegisterRoute: typeof LoginQuickRegisterRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/debug': {
      id: '/debug'
      path: '/debug'
      fullPath: '/debug'
      preLoaderRoute: typeof DebugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/login/quick-register': {
      id: '/login/quick-register'
      path: '/login/quick-register'
      fullPath: '/login/quick-register'
      preLoaderRoute: typeof LoginQuickRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/debug/$id': {
      id: '/debug/$id'
      path: '/$id'
      fullPath: '/debug/$id'
      preLoaderRoute: typeof DebugIdRouteImport
      parentRoute: typeof DebugRoute
    }
    '/colors/$id': {
      id: '/colors/$id'
      path: '/colors/$id'
      fullPath: '/colors/$id'
      preLoaderRoute: typeof ColorsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/magic-link': {
      id: '/_auth/magic-link'
      path: '/magic-link'
      fullPath: '/magic-link'
      preLoaderRoute: typeof AuthMagicLinkRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/home': {
      id: '/_auth/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthHomeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/favorites': {
      id: '/_auth/favorites'
      path: '/favorites'
      fullPath: '/favorites'
      preLoaderRoute: typeof AuthFavoritesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/auth-mobile': {
      id: '/_auth/auth-mobile'
      path: '/auth-mobile'
      fullPath: '/auth-mobile'
      preLoaderRoute: typeof AuthAuthMobileRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/auth': {
      id: '/_auth/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthAuthRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_layout': {
      id: '/_auth/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_buttonView': {
      id: '/_auth/_buttonView'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthButtonViewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/diploma/$id': {
      id: '/_auth/diploma/$id'
      path: '/diploma/$id'
      fullPath: '/diploma/$id'
      preLoaderRoute: typeof AuthDiplomaIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_buttonView/_layout': {
      id: '/_auth/_buttonView/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthButtonViewLayoutRouteImport
      parentRoute: typeof AuthButtonViewRoute
    }
    '/_auth/_buttonView/_layout/training': {
      id: '/_auth/_buttonView/_layout/training'
      path: '/training'
      fullPath: '/training'
      preLoaderRoute: typeof AuthButtonViewLayoutTrainingRouteImport
      parentRoute: typeof AuthButtonViewLayoutRoute
    }
    '/_auth/_buttonView/_layout/retain': {
      id: '/_auth/_buttonView/_layout/retain'
      path: '/retain'
      fullPath: '/retain'
      preLoaderRoute: typeof AuthButtonViewLayoutRetainRouteImport
      parentRoute: typeof AuthButtonViewLayoutRoute
    }
    '/_auth/_buttonView/_layout/resources': {
      id: '/_auth/_buttonView/_layout/resources'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof AuthButtonViewLayoutResourcesRouteImport
      parentRoute: typeof AuthButtonViewLayoutRoute
    }
    '/_auth/_layout/watch/': {
      id: '/_auth/_layout/watch/'
      path: '/watch'
      fullPath: '/watch'
      preLoaderRoute: typeof AuthLayoutWatchIndexRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_auth/_layout/suppliers/': {
      id: '/_auth/_layout/suppliers/'
      path: '/suppliers'
      fullPath: '/suppliers'
      preLoaderRoute: typeof AuthLayoutSuppliersIndexRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_auth/_layout/showcases/': {
      id: '/_auth/_layout/showcases/'
      path: '/showcases'
      fullPath: '/showcases'
      preLoaderRoute: typeof AuthLayoutShowcasesIndexRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_auth/_layout/my-source/': {
      id: '/_auth/_layout/my-source/'
      path: '/my-source'
      fullPath: '/my-source'
      preLoaderRoute: typeof AuthLayoutMySourceIndexRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_auth/_layout/micro-learnings/': {
      id: '/_auth/_layout/micro-learnings/'
      path: '/micro-learnings'
      fullPath: '/micro-learnings'
      preLoaderRoute: typeof AuthLayoutMicroLearningsIndexRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_auth/_layout/destinations/': {
      id: '/_auth/_layout/destinations/'
      path: '/destinations'
      fullPath: '/destinations'
      preLoaderRoute: typeof AuthLayoutDestinationsIndexRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_auth/_layout/attend/': {
      id: '/_auth/_layout/attend/'
      path: '/attend'
      fullPath: '/attend'
      preLoaderRoute: typeof AuthLayoutAttendIndexRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_auth/_layout/showcases/$id': {
      id: '/_auth/_layout/showcases/$id'
      path: '/showcases/$id'
      fullPath: '/showcases/$id'
      preLoaderRoute: typeof AuthLayoutShowcasesIdRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_auth/_layout/contact/$id': {
      id: '/_auth/_layout/contact/$id'
      path: '/contact/$id'
      fullPath: '/contact/$id'
      preLoaderRoute: typeof AuthLayoutContactIdRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_auth/_buttonView/_layout/training/': {
      id: '/_auth/_buttonView/_layout/training/'
      path: '/'
      fullPath: '/training/'
      preLoaderRoute: typeof AuthButtonViewLayoutTrainingIndexRouteImport
      parentRoute: typeof AuthButtonViewLayoutTrainingRoute
    }
    '/_auth/_buttonView/_layout/retain/': {
      id: '/_auth/_buttonView/_layout/retain/'
      path: '/'
      fullPath: '/retain/'
      preLoaderRoute: typeof AuthButtonViewLayoutRetainIndexRouteImport
      parentRoute: typeof AuthButtonViewLayoutRetainRoute
    }
    '/_auth/_buttonView/_layout/training/_app': {
      id: '/_auth/_buttonView/_layout/training/_app'
      path: '/training'
      fullPath: '/training'
      preLoaderRoute: typeof AuthButtonViewLayoutTrainingAppRouteImport
      parentRoute: typeof AuthButtonViewLayoutTrainingRoute
    }
    '/_auth/_buttonView/_layout/retain/_app': {
      id: '/_auth/_buttonView/_layout/retain/_app'
      path: '/retain'
      fullPath: '/retain'
      preLoaderRoute: typeof AuthButtonViewLayoutRetainAppRouteImport
      parentRoute: typeof AuthButtonViewLayoutRetainRoute
    }
    '/_auth/_buttonView/_layout/resources/_type': {
      id: '/_auth/_buttonView/_layout/resources/_type'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof AuthButtonViewLayoutResourcesTypeRouteImport
      parentRoute: typeof AuthButtonViewLayoutResourcesRoute
    }
    '/_auth/_buttonView/_layout/info/$id': {
      id: '/_auth/_buttonView/_layout/info/$id'
      path: '/info/$id'
      fullPath: '/info/$id'
      preLoaderRoute: typeof AuthButtonViewLayoutInfoIdRouteImport
      parentRoute: typeof AuthButtonViewLayoutRoute
    }
    '/_auth/_buttonView/_layout/favorites/$id': {
      id: '/_auth/_buttonView/_layout/favorites/$id'
      path: '/favorites/$id'
      fullPath: '/favorites/$id'
      preLoaderRoute: typeof AuthButtonViewLayoutFavoritesIdRouteImport
      parentRoute: typeof AuthButtonViewLayoutRoute
    }
    '/_auth/_buttonView/_layout/directory/$id': {
      id: '/_auth/_buttonView/_layout/directory/$id'
      path: '/directory/$id'
      fullPath: '/directory/$id'
      preLoaderRoute: typeof AuthButtonViewLayoutDirectoryIdRouteImport
      parentRoute: typeof AuthButtonViewLayoutRoute
    }
    '/_auth/_buttonView/_layout/training/_app/$id': {
      id: '/_auth/_buttonView/_layout/training/_app/$id'
      path: '/$id'
      fullPath: '/training/$id'
      preLoaderRoute: typeof AuthButtonViewLayoutTrainingAppIdRouteImport
      parentRoute: typeof AuthButtonViewLayoutTrainingAppRoute
    }
    '/_auth/_buttonView/_layout/retain/_app/$id': {
      id: '/_auth/_buttonView/_layout/retain/_app/$id'
      path: '/$id'
      fullPath: '/retain/$id'
      preLoaderRoute: typeof AuthButtonViewLayoutRetainAppIdRouteImport
      parentRoute: typeof AuthButtonViewLayoutRetainAppRoute
    }
    '/_auth/_buttonView/_layout/resources/_type/$type': {
      id: '/_auth/_buttonView/_layout/resources/_type/$type'
      path: '/$type'
      fullPath: '/resources/$type'
      preLoaderRoute: typeof AuthButtonViewLayoutResourcesTypeTypeRouteImport
      parentRoute: typeof AuthButtonViewLayoutResourcesTypeRoute
    }
    '/_auth/_buttonView/_layout/training/_app/$id/': {
      id: '/_auth/_buttonView/_layout/training/_app/$id/'
      path: '/'
      fullPath: '/training/$id/'
      preLoaderRoute: typeof AuthButtonViewLayoutTrainingAppIdIndexRouteImport
      parentRoute: typeof AuthButtonViewLayoutTrainingAppIdRoute
    }
    '/_auth/_buttonView/_layout/retain/_app/$id/': {
      id: '/_auth/_buttonView/_layout/retain/_app/$id/'
      path: '/'
      fullPath: '/retain/$id/'
      preLoaderRoute: typeof AuthButtonViewLayoutRetainAppIdIndexRouteImport
      parentRoute: typeof AuthButtonViewLayoutRetainAppIdRoute
    }
    '/_auth/_buttonView/_layout/training/_app/$id/_content': {
      id: '/_auth/_buttonView/_layout/training/_app/$id/_content'
      path: ''
      fullPath: '/training/$id'
      preLoaderRoute: typeof AuthButtonViewLayoutTrainingAppIdContentRouteImport
      parentRoute: typeof AuthButtonViewLayoutTrainingAppIdRoute
    }
    '/_auth/_buttonView/_layout/resources/_type/$type/_id': {
      id: '/_auth/_buttonView/_layout/resources/_type/$type/_id'
      path: ''
      fullPath: '/resources/$type'
      preLoaderRoute: typeof AuthButtonViewLayoutResourcesTypeTypeIdRouteImport
      parentRoute: typeof AuthButtonViewLayoutResourcesTypeTypeRoute
    }
    '/_auth/_buttonView/_layout/retain/_app/$id/$chapter/': {
      id: '/_auth/_buttonView/_layout/retain/_app/$id/$chapter/'
      path: '/$chapter'
      fullPath: '/retain/$id/$chapter'
      preLoaderRoute: typeof AuthButtonViewLayoutRetainAppIdChapterIndexRouteImport
      parentRoute: typeof AuthButtonViewLayoutRetainAppIdRoute
    }
    '/_auth/_buttonView/_layout/resources/_type/$type/_id/$id/': {
      id: '/_auth/_buttonView/_layout/resources/_type/$type/_id/$id/'
      path: '/$id'
      fullPath: '/resources/$type/$id'
      preLoaderRoute: typeof AuthButtonViewLayoutResourcesTypeTypeIdIdIndexRouteImport
      parentRoute: typeof AuthButtonViewLayoutResourcesTypeTypeIdRoute
    }
    '/_auth/_buttonView/_layout/training/_app/$id/_content/$chapter/$page': {
      id: '/_auth/_buttonView/_layout/training/_app/$id/_content/$chapter/$page'
      path: '/$chapter/$page'
      fullPath: '/training/$id/$chapter/$page'
      preLoaderRoute: typeof AuthButtonViewLayoutTrainingAppIdContentChapterPageRouteImport
      parentRoute: typeof AuthButtonViewLayoutTrainingAppIdContentRoute
    }
    '/_auth/_buttonView/_layout/resources/_type/$type/_id/$id/library/': {
      id: '/_auth/_buttonView/_layout/resources/_type/$type/_id/$id/library/'
      path: '/$id/library'
      fullPath: '/resources/$type/$id/library'
      preLoaderRoute: typeof AuthButtonViewLayoutResourcesTypeTypeIdIdLibraryIndexRouteImport
      parentRoute: typeof AuthButtonViewLayoutResourcesTypeTypeIdRoute
    }
  }
}

interface AuthButtonViewLayoutResourcesTypeTypeIdRouteChildren {
  AuthButtonViewLayoutResourcesTypeTypeIdIdIndexRoute: typeof AuthButtonViewLayoutResourcesTypeTypeIdIdIndexRoute
  AuthButtonViewLayoutResourcesTypeTypeIdIdLibraryIndexRoute: typeof AuthButtonViewLayoutResourcesTypeTypeIdIdLibraryIndexRoute
}

const AuthButtonViewLayoutResourcesTypeTypeIdRouteChildren: AuthButtonViewLayoutResourcesTypeTypeIdRouteChildren =
  {
    AuthButtonViewLayoutResourcesTypeTypeIdIdIndexRoute:
      AuthButtonViewLayoutResourcesTypeTypeIdIdIndexRoute,
    AuthButtonViewLayoutResourcesTypeTypeIdIdLibraryIndexRoute:
      AuthButtonViewLayoutResourcesTypeTypeIdIdLibraryIndexRoute,
  }

const AuthButtonViewLayoutResourcesTypeTypeIdRouteWithChildren =
  AuthButtonViewLayoutResourcesTypeTypeIdRoute._addFileChildren(
    AuthButtonViewLayoutResourcesTypeTypeIdRouteChildren,
  )

interface AuthButtonViewLayoutResourcesTypeTypeRouteChildren {
  AuthButtonViewLayoutResourcesTypeTypeIdRoute: typeof AuthButtonViewLayoutResourcesTypeTypeIdRouteWithChildren
}

const AuthButtonViewLayoutResourcesTypeTypeRouteChildren: AuthButtonViewLayoutResourcesTypeTypeRouteChildren =
  {
    AuthButtonViewLayoutResourcesTypeTypeIdRoute:
      AuthButtonViewLayoutResourcesTypeTypeIdRouteWithChildren,
  }

const AuthButtonViewLayoutResourcesTypeTypeRouteWithChildren =
  AuthButtonViewLayoutResourcesTypeTypeRoute._addFileChildren(
    AuthButtonViewLayoutResourcesTypeTypeRouteChildren,
  )

interface AuthButtonViewLayoutResourcesTypeRouteChildren {
  AuthButtonViewLayoutResourcesTypeTypeRoute: typeof AuthButtonViewLayoutResourcesTypeTypeRouteWithChildren
}

const AuthButtonViewLayoutResourcesTypeRouteChildren: AuthButtonViewLayoutResourcesTypeRouteChildren =
  {
    AuthButtonViewLayoutResourcesTypeTypeRoute:
      AuthButtonViewLayoutResourcesTypeTypeRouteWithChildren,
  }

const AuthButtonViewLayoutResourcesTypeRouteWithChildren =
  AuthButtonViewLayoutResourcesTypeRoute._addFileChildren(
    AuthButtonViewLayoutResourcesTypeRouteChildren,
  )

interface AuthButtonViewLayoutResourcesRouteChildren {
  AuthButtonViewLayoutResourcesTypeRoute: typeof AuthButtonViewLayoutResourcesTypeRouteWithChildren
}

const AuthButtonViewLayoutResourcesRouteChildren: AuthButtonViewLayoutResourcesRouteChildren =
  {
    AuthButtonViewLayoutResourcesTypeRoute:
      AuthButtonViewLayoutResourcesTypeRouteWithChildren,
  }

const AuthButtonViewLayoutResourcesRouteWithChildren =
  AuthButtonViewLayoutResourcesRoute._addFileChildren(
    AuthButtonViewLayoutResourcesRouteChildren,
  )

interface AuthButtonViewLayoutRetainAppIdRouteChildren {
  AuthButtonViewLayoutRetainAppIdIndexRoute: typeof AuthButtonViewLayoutRetainAppIdIndexRoute
  AuthButtonViewLayoutRetainAppIdChapterIndexRoute: typeof AuthButtonViewLayoutRetainAppIdChapterIndexRoute
}

const AuthButtonViewLayoutRetainAppIdRouteChildren: AuthButtonViewLayoutRetainAppIdRouteChildren =
  {
    AuthButtonViewLayoutRetainAppIdIndexRoute:
      AuthButtonViewLayoutRetainAppIdIndexRoute,
    AuthButtonViewLayoutRetainAppIdChapterIndexRoute:
      AuthButtonViewLayoutRetainAppIdChapterIndexRoute,
  }

const AuthButtonViewLayoutRetainAppIdRouteWithChildren =
  AuthButtonViewLayoutRetainAppIdRoute._addFileChildren(
    AuthButtonViewLayoutRetainAppIdRouteChildren,
  )

interface AuthButtonViewLayoutRetainAppRouteChildren {
  AuthButtonViewLayoutRetainAppIdRoute: typeof AuthButtonViewLayoutRetainAppIdRouteWithChildren
}

const AuthButtonViewLayoutRetainAppRouteChildren: AuthButtonViewLayoutRetainAppRouteChildren =
  {
    AuthButtonViewLayoutRetainAppIdRoute:
      AuthButtonViewLayoutRetainAppIdRouteWithChildren,
  }

const AuthButtonViewLayoutRetainAppRouteWithChildren =
  AuthButtonViewLayoutRetainAppRoute._addFileChildren(
    AuthButtonViewLayoutRetainAppRouteChildren,
  )

interface AuthButtonViewLayoutRetainRouteChildren {
  AuthButtonViewLayoutRetainAppRoute: typeof AuthButtonViewLayoutRetainAppRouteWithChildren
  AuthButtonViewLayoutRetainIndexRoute: typeof AuthButtonViewLayoutRetainIndexRoute
}

const AuthButtonViewLayoutRetainRouteChildren: AuthButtonViewLayoutRetainRouteChildren =
  {
    AuthButtonViewLayoutRetainAppRoute:
      AuthButtonViewLayoutRetainAppRouteWithChildren,
    AuthButtonViewLayoutRetainIndexRoute: AuthButtonViewLayoutRetainIndexRoute,
  }

const AuthButtonViewLayoutRetainRouteWithChildren =
  AuthButtonViewLayoutRetainRoute._addFileChildren(
    AuthButtonViewLayoutRetainRouteChildren,
  )

interface AuthButtonViewLayoutTrainingAppIdContentRouteChildren {
  AuthButtonViewLayoutTrainingAppIdContentChapterPageRoute: typeof AuthButtonViewLayoutTrainingAppIdContentChapterPageRoute
}

const AuthButtonViewLayoutTrainingAppIdContentRouteChildren: AuthButtonViewLayoutTrainingAppIdContentRouteChildren =
  {
    AuthButtonViewLayoutTrainingAppIdContentChapterPageRoute:
      AuthButtonViewLayoutTrainingAppIdContentChapterPageRoute,
  }

const AuthButtonViewLayoutTrainingAppIdContentRouteWithChildren =
  AuthButtonViewLayoutTrainingAppIdContentRoute._addFileChildren(
    AuthButtonViewLayoutTrainingAppIdContentRouteChildren,
  )

interface AuthButtonViewLayoutTrainingAppIdRouteChildren {
  AuthButtonViewLayoutTrainingAppIdContentRoute: typeof AuthButtonViewLayoutTrainingAppIdContentRouteWithChildren
  AuthButtonViewLayoutTrainingAppIdIndexRoute: typeof AuthButtonViewLayoutTrainingAppIdIndexRoute
}

const AuthButtonViewLayoutTrainingAppIdRouteChildren: AuthButtonViewLayoutTrainingAppIdRouteChildren =
  {
    AuthButtonViewLayoutTrainingAppIdContentRoute:
      AuthButtonViewLayoutTrainingAppIdContentRouteWithChildren,
    AuthButtonViewLayoutTrainingAppIdIndexRoute:
      AuthButtonViewLayoutTrainingAppIdIndexRoute,
  }

const AuthButtonViewLayoutTrainingAppIdRouteWithChildren =
  AuthButtonViewLayoutTrainingAppIdRoute._addFileChildren(
    AuthButtonViewLayoutTrainingAppIdRouteChildren,
  )

interface AuthButtonViewLayoutTrainingAppRouteChildren {
  AuthButtonViewLayoutTrainingAppIdRoute: typeof AuthButtonViewLayoutTrainingAppIdRouteWithChildren
}

const AuthButtonViewLayoutTrainingAppRouteChildren: AuthButtonViewLayoutTrainingAppRouteChildren =
  {
    AuthButtonViewLayoutTrainingAppIdRoute:
      AuthButtonViewLayoutTrainingAppIdRouteWithChildren,
  }

const AuthButtonViewLayoutTrainingAppRouteWithChildren =
  AuthButtonViewLayoutTrainingAppRoute._addFileChildren(
    AuthButtonViewLayoutTrainingAppRouteChildren,
  )

interface AuthButtonViewLayoutTrainingRouteChildren {
  AuthButtonViewLayoutTrainingAppRoute: typeof AuthButtonViewLayoutTrainingAppRouteWithChildren
  AuthButtonViewLayoutTrainingIndexRoute: typeof AuthButtonViewLayoutTrainingIndexRoute
}

const AuthButtonViewLayoutTrainingRouteChildren: AuthButtonViewLayoutTrainingRouteChildren =
  {
    AuthButtonViewLayoutTrainingAppRoute:
      AuthButtonViewLayoutTrainingAppRouteWithChildren,
    AuthButtonViewLayoutTrainingIndexRoute:
      AuthButtonViewLayoutTrainingIndexRoute,
  }

const AuthButtonViewLayoutTrainingRouteWithChildren =
  AuthButtonViewLayoutTrainingRoute._addFileChildren(
    AuthButtonViewLayoutTrainingRouteChildren,
  )

interface AuthButtonViewLayoutRouteChildren {
  AuthButtonViewLayoutDirectoryIdRoute: typeof AuthButtonViewLayoutDirectoryIdRoute
  AuthButtonViewLayoutFavoritesIdRoute: typeof AuthButtonViewLayoutFavoritesIdRoute
  AuthButtonViewLayoutInfoIdRoute: typeof AuthButtonViewLayoutInfoIdRoute
  AuthButtonViewLayoutResourcesRoute: typeof AuthButtonViewLayoutResourcesRouteWithChildren
  AuthButtonViewLayoutRetainRoute: typeof AuthButtonViewLayoutRetainRouteWithChildren
  AuthButtonViewLayoutTrainingRoute: typeof AuthButtonViewLayoutTrainingRouteWithChildren
}

const AuthButtonViewLayoutRouteChildren: AuthButtonViewLayoutRouteChildren = {
  AuthButtonViewLayoutDirectoryIdRoute: AuthButtonViewLayoutDirectoryIdRoute,
  AuthButtonViewLayoutFavoritesIdRoute: AuthButtonViewLayoutFavoritesIdRoute,
  AuthButtonViewLayoutInfoIdRoute: AuthButtonViewLayoutInfoIdRoute,
  AuthButtonViewLayoutResourcesRoute:
    AuthButtonViewLayoutResourcesRouteWithChildren,
  AuthButtonViewLayoutRetainRoute: AuthButtonViewLayoutRetainRouteWithChildren,
  AuthButtonViewLayoutTrainingRoute:
    AuthButtonViewLayoutTrainingRouteWithChildren,
}

const AuthButtonViewLayoutRouteWithChildren =
  AuthButtonViewLayoutRoute._addFileChildren(AuthButtonViewLayoutRouteChildren)

interface AuthButtonViewRouteChildren {
  AuthButtonViewLayoutRoute: typeof AuthButtonViewLayoutRouteWithChildren
}

const AuthButtonViewRouteChildren: AuthButtonViewRouteChildren = {
  AuthButtonViewLayoutRoute: AuthButtonViewLayoutRouteWithChildren,
}

const AuthButtonViewRouteWithChildren = AuthButtonViewRoute._addFileChildren(
  AuthButtonViewRouteChildren,
)

interface AuthLayoutRouteChildren {
  AuthLayoutContactIdRoute: typeof AuthLayoutContactIdRoute
  AuthLayoutShowcasesIdRoute: typeof AuthLayoutShowcasesIdRoute
  AuthLayoutAttendIndexRoute: typeof AuthLayoutAttendIndexRoute
  AuthLayoutDestinationsIndexRoute: typeof AuthLayoutDestinationsIndexRoute
  AuthLayoutMicroLearningsIndexRoute: typeof AuthLayoutMicroLearningsIndexRoute
  AuthLayoutMySourceIndexRoute: typeof AuthLayoutMySourceIndexRoute
  AuthLayoutShowcasesIndexRoute: typeof AuthLayoutShowcasesIndexRoute
  AuthLayoutSuppliersIndexRoute: typeof AuthLayoutSuppliersIndexRoute
  AuthLayoutWatchIndexRoute: typeof AuthLayoutWatchIndexRoute
}

const AuthLayoutRouteChildren: AuthLayoutRouteChildren = {
  AuthLayoutContactIdRoute: AuthLayoutContactIdRoute,
  AuthLayoutShowcasesIdRoute: AuthLayoutShowcasesIdRoute,
  AuthLayoutAttendIndexRoute: AuthLayoutAttendIndexRoute,
  AuthLayoutDestinationsIndexRoute: AuthLayoutDestinationsIndexRoute,
  AuthLayoutMicroLearningsIndexRoute: AuthLayoutMicroLearningsIndexRoute,
  AuthLayoutMySourceIndexRoute: AuthLayoutMySourceIndexRoute,
  AuthLayoutShowcasesIndexRoute: AuthLayoutShowcasesIndexRoute,
  AuthLayoutSuppliersIndexRoute: AuthLayoutSuppliersIndexRoute,
  AuthLayoutWatchIndexRoute: AuthLayoutWatchIndexRoute,
}

const AuthLayoutRouteWithChildren = AuthLayoutRoute._addFileChildren(
  AuthLayoutRouteChildren,
)

interface AuthRouteChildren {
  AuthButtonViewRoute: typeof AuthButtonViewRouteWithChildren
  AuthLayoutRoute: typeof AuthLayoutRouteWithChildren
  AuthAuthRoute: typeof AuthAuthRoute
  AuthAuthMobileRoute: typeof AuthAuthMobileRoute
  AuthFavoritesRoute: typeof AuthFavoritesRoute
  AuthHomeRoute: typeof AuthHomeRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthMagicLinkRoute: typeof AuthMagicLinkRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthDiplomaIdRoute: typeof AuthDiplomaIdRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthButtonViewRoute: AuthButtonViewRouteWithChildren,
  AuthLayoutRoute: AuthLayoutRouteWithChildren,
  AuthAuthRoute: AuthAuthRoute,
  AuthAuthMobileRoute: AuthAuthMobileRoute,
  AuthFavoritesRoute: AuthFavoritesRoute,
  AuthHomeRoute: AuthHomeRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthMagicLinkRoute: AuthMagicLinkRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthDiplomaIdRoute: AuthDiplomaIdRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface DebugRouteChildren {
  DebugIdRoute: typeof DebugIdRoute
}

const DebugRouteChildren: DebugRouteChildren = {
  DebugIdRoute: DebugIdRoute,
}

const DebugRouteWithChildren = DebugRoute._addFileChildren(DebugRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  R404Route: R404Route,
  AuthRoute: AuthRouteWithChildren,
  DebugRoute: DebugRouteWithChildren,
  ColorsIdRoute: ColorsIdRoute,
  LoginQuickRegisterRoute: LoginQuickRegisterRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
